import { getAuthToken } from '@/lib/api/authToken'
import { bindJPushRegistrationID } from '@/lib/api/jpushApi'
import { initAndListenRegistrationID } from '@/lib/jpush'
import { useAppSelector } from '@/redux/store'
import { useEffect, useRef } from 'react'

/**
 * 这个组件负责在用户登录成功后，自动获取 JPush registrationID 并绑定到后端
 * 需要放在应用的主布局中，确保在登录后能够正常工作
 */
export default function JPushRegistrationHandler() {
  const signedIn = useAppSelector(state => state.session.signedIn)
  const listenerCleanupRef = useRef<(() => void) | null>(null)

  useEffect(() => {
    console.log('[JPushRegistrationHandler] useEffect 触发，signedIn:', signedIn)

    if (!signedIn) {
      // 如果用户未登录，清理之前的监听器
      console.log('[JPushRegistrationHandler] 用户未登录，清理之前的监听器')
      if (listenerCleanupRef.current) {
        listenerCleanupRef.current()
        listenerCleanupRef.current = null
        console.log('[JPushRegistrationHandler] 监听器已清理')
      }
      return
    }

    // 用户已登录，开始监听 registrationID
    console.log('[JPushRegistrationHandler] ✅ 用户已登录，开始监听 RegistrationID...')

    const cleanup = initAndListenRegistrationID(async (registrationID: string) => {
      try {
        console.log('[JPushRegistrationHandler] 📤 尝试绑定 RegistrationID 到用户:', registrationID)

        // 获取当前用户 token
        const currentToken = getAuthToken()
        if (!currentToken) {
          console.error('[JPushRegistrationHandler] ❌ 无法获取用户 token')
          return
        }

        // 绑定新的 RegistrationID
        console.log('[JPushRegistrationHandler] 使用 userToken:', currentToken)
        await bindJPushRegistrationID(registrationID, currentToken)
      } catch (error) {
        console.error('[JPushRegistrationHandler] ❌ 绑定 RegistrationID 时出错:', error)
      }
    })

    listenerCleanupRef.current = cleanup
    console.log('[JPushRegistrationHandler] 监听器已设置')

    // 清理函数
    return () => {
      console.log('[JPushRegistrationHandler] 清理监听器...')
      cleanup()
      listenerCleanupRef.current = null
      console.log('[JPushRegistrationHandler] 监听器已清理')
    }
  }, [signedIn])

  // 这个组件不渲染任何内容
  return null
}
